/* Native disclosure menus and direction-aware navigation. No scroll interception. */
(() => {
  'use strict';
  if (window.TMHeaderInstalled) return;
  window.TMHeaderInstalled = true;
  function mount(header) {
    if (!header || header.dataset.headerReady) return;
    header.dataset.headerReady = 'true';
    const controller = new AbortController(), {signal} = controller;
    const mobileMenu = header.closest('.shopify-section')?.querySelector('#menu-dialog');
    mobileMenu?.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (link && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) mobileMenu.close();
    }, {signal});
    const menus = [...header.querySelectorAll('[data-header-menu]')];
    const hover = matchMedia('(hover:hover) and (pointer:fine)');
    let leaveTimer, frame = 0, lastY = Math.max(0, scrollY), distance = 0, direction = 0;
    const reveal = () => header.classList.remove('is-scroll-hidden');
    const closeMenus = (except) => menus.forEach(menu => { if (menu !== except) menu.open = false; });
    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      summary.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) { closeMenus(menu); reveal(); }
      }, {signal});
      menu.addEventListener('pointerenter', () => {
        clearTimeout(leaveTimer);
        if (hover.matches) { closeMenus(menu); menu.open = true; reveal(); }
      }, {signal});
      menu.addEventListener('pointerleave', () => {
        if (hover.matches) leaveTimer = setTimeout(() => { if (!menu.contains(document.activeElement) || !document.activeElement.matches(':focus-visible')) menu.open = false; }, 180);
      }, {signal});
      summary.addEventListener('click', event => {
        if (event.detail > 0 && hover.matches) { event.preventDefault(); closeMenus(menu); menu.open = true; reveal(); }
      }, {signal});
      summary.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') { event.preventDefault(); closeMenus(menu); menu.open = true; menu.querySelector('.tm-mega a')?.focus({preventScroll:true}); }
      }, {signal});
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const current = menus.find(menu => menu.open);
      if (current) { event.preventDefault(); current.open = false; current.querySelector('summary').focus({preventScroll:true}); }
    }, {signal});
    header.addEventListener('focusin', reveal, {signal});
    header.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!header.contains(document.activeElement)) closeMenus();
    }), {signal});
    document.addEventListener('pointerdown', event => { if (!header.contains(event.target)) closeMenus(); }, {signal});
    const update = () => {
      frame = 0;
      const y = Math.max(0,Math.min(scrollY,document.documentElement.scrollHeight-innerHeight));
      const delta = y-lastY; lastY=y;
      const keyboardFocused = header.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      const locked = keyboardFocused || menus.some(menu=>menu.open) || document.querySelector('dialog[open]');
      if (y <= header.offsetHeight || locked) { reveal(); distance=0; return; }
      if (Math.abs(delta)<1) return;
      const nextDirection = Math.sign(delta);
      if (nextDirection !== direction) distance=0;
      direction=nextDirection;distance+=Math.abs(delta);
      if (distance >= (direction>0?18:8)) { header.classList.toggle('is-scroll-hidden',direction>0); distance=0; }
    };
    if (header.dataset.scrollMode === 'auto') {
      addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true,signal});
      addEventListener('pageshow',()=>{lastY=Math.max(0,scrollY);distance=0;reveal();},{signal});
    }
    const breakpoint = matchMedia('(max-width:1000px)');
    breakpoint.addEventListener('change',()=>{closeMenus();reveal();},{signal});
    header.tmCleanup=()=>{controller.abort();clearTimeout(leaveTimer);cancelAnimationFrame(frame);};
  }
  document.querySelectorAll('[data-site-header]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-site-header]').forEach(mount));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-site-header]')?.tmCleanup?.());
})();
